import { useWindowSize } from 'react-use';

export function useScale(px: number, baseWidth = 720) {
  const { width } = useWindowSize();
  const ratio = px * (1 / baseWidth) * 2.0;
  return ratio * width;
}
